/* eslint-disable max-lines */
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AirIcon from '@mui/icons-material/Air'
import { useI18n } from '@popety_io/popety-io-lib'

import { getIndexData } from './EstimateAirQuality.utils'

const AirQualitySummary = ({
  totalAverage,
  minAqi,
  maxAqi,
}: {
  totalAverage: number
  minAqi: { aqi: number; date: string; distance: string; hour: string }
  maxAqi: { aqi: number; date: string; distance: string; hour: string }
}) => {
  const { t } = useI18n()

  const [item, setItem] = useState<any>(null)
  const [minAqiItem, setMinAqiItem] = useState<any>(undefined)
  const [maxAqiItem, setMaxAqiItem] = useState<any>(undefined)

  useEffect(() => {
    if (!totalAverage) return

    const indexData = getIndexData(t)

    setItem(
      indexData?.items?.find(
        (item) => totalAverage <= item.max || item.max === Infinity,
      ),
    )

    setMinAqiItem(
      indexData?.items?.find(
        (item) => minAqi.aqi <= item.max || item.max === Infinity,
      ),
    )

    setMaxAqiItem(
      indexData?.items?.find(
        (item) => maxAqi.aqi <= item.max || item.max === Infinity,
      ),
    )
  }, [totalAverage])

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '40px',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', md: '45%' },
          paddingRight: { xs: 0, md: '20px' },
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <AirIcon
            sx={{
              fontSize: '2.5rem',
              color: '#00ade6',
            }}
          />
          <Typography variant="h3" fontSize="1.2rem">
            {t('common.air_quality_index')}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '10px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 6,
            }}
          >
            <Typography
              variant="body1"
              fontSize="1rem"
              sx={{
                color: '#969696',
              }}
            >
              Minimum
            </Typography>

            <Typography
              variant="body1"
              fontSize="1rem"
              sx={{
                color: '#969696',
                marginLeft: '3px',
              }}
            >
              <span
                style={{
                  color: minAqiItem?.color,
                  fontWeight: 500,
                  fontSize: '1.2rem',
                }}
              >
                {minAqiItem?.value ? minAqiItem?.value : ''}
              </span>
              - {minAqi?.date}{' '}
              {minAqi?.hour ? `${t('common.at')} ${minAqi?.hour}` : ''}{' '}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 6,
            }}
          >
            <Typography
              variant="body1"
              fontSize="1rem"
              sx={{
                color: '#969696',
              }}
            >
              Maximum
            </Typography>
            <Typography
              variant="body1"
              fontSize="1rem"
              sx={{
                color: '#969696',
              }}
            >
              <span
                style={{
                  color: maxAqiItem?.color,
                  fontWeight: 500,
                  fontSize: '1.2rem',
                }}
              >
                {maxAqiItem?.value}{' '}
              </span>
              - {maxAqi?.date} at {maxAqi?.hour}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: '100%', md: '45%' },
          paddingRight: { xs: 0, md: '20px' },
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            width: 'fit-content',
          }}
        >
          <Typography
            sx={{
              fontSize: '2.2rem',
              fontWeight: 500,
              color: item?.color,
              textAlign: 'center',
            }}
          >
            {item?.text}
          </Typography>
          <Typography
            sx={{
              textAlign: 'center',
              fontSize: '1.1rem',
            }}
          >
            {t('common.air_quality_mesured')}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default AirQualitySummary
